import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { createAxiosInstance } from "../axiosSettings";
import { logout } from "./authSlice";

const initialState = {
  isLoading: false,
  usersList : [],
  b2bUsers : [],
  userAttendance : [],
  reviews : [],
  userData : null,
  editAgentData : null,
  userTruck : null,
  error : null
};


export const USER_API = "admin/user";
export const AGENT_DETAIL = "admin/user/detail";
export const USER_TRUCK = "admin/user/assigned/user_truck";

export const getUsersList = createAsyncThunk(
  USER_API,
  async (formData, { rejectWithValue }) => {
    const axiosInstance = await createAxiosInstance();
    try {
      const response = await axiosInstance.get(USER_API, {
        params : formData
      });
      if (response.data) {
        return response.data;
      } else {
        return rejectWithValue(response.data.message || "Error");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error"
      );
    }
  }
);

export const getUserById = createAsyncThunk(
  AGENT_DETAIL + '/agent-by-id',
  async (id, { rejectWithValue }) => {
    const axiosInstance = await createAxiosInstance();
    try {
      const response = await axiosInstance.get(AGENT_DETAIL + '/' + id)
      if (response.data) {
        return response.data;
      } else {
        return rejectWithValue(response.data || "Error");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Error"
      );
    }
  }
);

export const createAgent = createAsyncThunk(
  USER_API + '/create-agent',
  async (data, { rejectWithValue }) => {
    const axiosInstance = await createAxiosInstance();
    try {
      const response = await axiosInstance.post(USER_API, data)
      if (response.data) {
        return response.data;
      } else {
        return rejectWithValue(response.data || "Error");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Error"
      );
    }
  }
);

export const updateUser = createAsyncThunk(
  USER_API + '/update-agent',
  async (data, { rejectWithValue }) => {
    const axiosInstance = await createAxiosInstance();
    try {
      const id = data?.get('id')
      const response = await axiosInstance.post(USER_API + '/update/' + id, data)
      if (response.data) {
        return response.data;
      } else {
        return rejectWithValue(response.data || "Error");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Error"
      );
    }
  }
);

export const updateUserTruck = createAsyncThunk(
  USER_TRUCK,
  async (data, { rejectWithValue }) => {
    const axiosInstance = await createAxiosInstance();
    try {
      const response = await axiosInstance.post(USER_TRUCK, data)
      if (response.data) {
        return response.data;
      } else {
        return rejectWithValue(response.data || "Error");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Error"
      );
    }
  }
);

export const getB2BUsers = createAsyncThunk(
  USER_API + "/b2b-users",
  async (formData, { rejectWithValue }) => {
    const axiosInstance = await createAxiosInstance();
    try {
      const response = await axiosInstance.get(USER_API + "/b2b-users", {
        params : formData
      });
      if (response.data) {
        return response.data;
      } else {
        return rejectWithValue(response.data.message || "Error");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error"
      );
    }
  }
);

export const deleteCustomer = createAsyncThunk(
  USER_API + '/delete-customer',
  async (data, { rejectWithValue }) => {
    const axiosInstance = await createAxiosInstance();
    try {
      // const id = formData.get('id')
      const response = await axiosInstance.post(USER_API + '/delete-customer', data);
      if (response.data) {
        return response.data;
      } else {
        return rejectWithValue(response.data.message || "Error");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error"
      );
    }
  }
);

export const getUsersForJobAssigning = createAsyncThunk(
  USER_API + "/users-for-job-assigning",
  async (formData, { rejectWithValue }) => {
    const axiosInstance = await createAxiosInstance();
    try {
      const response = await axiosInstance.get(USER_API + "/users-for-job-assigning", {
        params : formData
      });
      if (response.data) {
        return response.data;
      } else {
        return rejectWithValue(response.data.message || "Error");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error"
      );
    }
  }
);

export const getUserAttendance = createAsyncThunk(
  USER_API + "/get-user-attendance",
  async (formData, { rejectWithValue }) => {
    const axiosInstance = await createAxiosInstance();
    try {
      const response = await axiosInstance.get(USER_API + "/get-user-attendance", {
        params : formData
      });
      if (response.data) {
        return response.data;
      } else {
        return rejectWithValue(response.data.message || "Error");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error"
      );
    }
  }
);

export const getReviews = createAsyncThunk(
  USER_API + "/get-reviews",
  async (formData, { rejectWithValue }) => {
    const axiosInstance = await createAxiosInstance();
    try {
      const response = await axiosInstance.get(USER_API + "/get-reviews", {
        params : formData
      });
      if (response.data) {
        return response.data;
      } else {
        return rejectWithValue(response.data.message || "Error");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error"
      );
    }
  }
);

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    clearUsersList: (state) => {
      state.usersList = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUsersList.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getUsersList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.usersList = action.payload;
      })
      .addCase(getUsersList.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      //get agent by id
      .addCase(getUserById.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getUserById.fulfilled, (state, action) => {
        state.isLoading = false;
        state.userData = action.payload;
      })
      .addCase(getUserById.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      //create agent
      .addCase(createAgent.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(createAgent.fulfilled, (state, action) => {
        state.isLoading = false;
        state.userData = action.payload;
      })
      .addCase(createAgent.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      //update agent
      .addCase(updateUser.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.editAgentData = action.payload;
      })
      .addCase(updateUser.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      //update user truck
      .addCase(updateUserTruck.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateUserTruck.fulfilled, (state, action) => {
        state.isLoading = false;
        state.userTruck = action.payload;
      })
      .addCase(updateUserTruck.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      //get b2b users
      .addCase(getB2BUsers.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getB2BUsers.fulfilled, (state, action) => {
        state.isLoading = false;
        state.b2bUsers = action.payload;
      })
      .addCase(getB2BUsers.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })

      //get user for job assiging
      .addCase(getUsersForJobAssigning.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getUsersForJobAssigning.fulfilled, (state, action) => {
        state.isLoading = false;
        state.usersList = action.payload;
      })
      .addCase(getUsersForJobAssigning.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })

      //user attendance
      .addCase(getUserAttendance.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getUserAttendance.fulfilled, (state, action) => {
        state.isLoading = false;
        state.userAttendance = action.payload;
      })
      .addCase(getUserAttendance.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })

       //get reviews
      .addCase(getReviews.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getReviews.fulfilled, (state, action) => {
        state.isLoading = false;
        state.reviews = action.payload;
      })
      .addCase(getReviews.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(logout, () => initialState);
  },
});
export const exportToCSV = (data, fileName, cols) => {
  const headers = cols.map(col => col.title);
  headers.pop()
  const rows = data.map(row =>
    headers.map((header, index) => {
      const key = cols[index].dataIndex;
      const value = row[key];
      if (typeof value === "object" && value !== null) {
        return value?.code ?? "";
      }
      return value ?? "";
    })
  );
  const newHeaders = headers.map((data) => {
      let header = data?.replace('_', ' ')
      return header.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ")
  })
  const csvContent = [newHeaders, ...rows].join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = fileName;
  link.click();
};
export const { clearUsersList } = userSlice.actions
export default userSlice.reducer;